import { render, staticRenderFns } from "./datasetView.vue?vue&type=template&id=e637af96"
import script from "./datasetView.vue?vue&type=script&lang=js"
export * from "./datasetView.vue?vue&type=script&lang=js"
import style0 from "./datasetView.vue?vue&type=style&index=0&id=e637af96&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e637af96')) {
      api.createRecord('e637af96', component.options)
    } else {
      api.reload('e637af96', component.options)
    }
    module.hot.accept("./datasetView.vue?vue&type=template&id=e637af96", function () {
      api.rerender('e637af96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/datasetView/src/datasetView.vue"
export default component.exports